module.exports = __webpack_public_path__ + "img/icon_people_fill.d43e2ff0.png";